import { requestHelpers } from '../../helpers';

const actions = {
    GET_MEDIA: 'GET_MEDIA',
    GET_SINGLE_MEDIA: 'GET_SINGLE_MEDIA',
    OPEN_PLAYER: 'OPEN_PLAYER',
    CLOSE_PLAYER: 'CLOSE_PLAYER'
};

function openPlayer(tracks, currentIndex) {
    const body = document.body;
    body.classList.add('podcast-open')
    return dispatch => {
        const currentMp3 = currentIndex ? currentIndex : 0;
        dispatch({
            type: actions.OPEN_PLAYER,
            showMp3: true,
            mp3Tracks: tracks,
            currentIndex: currentMp3
        })
    }
}


function closePlayer() {
    const body = document.body;
    body.classList.remove('podcast-open')
    return({
        type: actions.OPEN_PLAYER,
        showMp3: false,
    })
}

function getMedia( options, page ) {

    return ( dispatch ) => {

        let newOptions;

        if( !options || options === null ) {
            newOptions = options = {};
        } else {
            newOptions = { ...options };
        }

        if( !page ) {
            newOptions.page = 1;
        }else {
            newOptions.page = page;
        }
        
        requestHelpers
            .authenticatedGetRequest( '/blogs', newOptions )
            .then( ( response ) => {
                return dispatch( {
                    type: actions.GET_MEDIA,
                    media: response.data,
                    // pagination: response.meta,
                    // options,
                } )
        } )
        .catch( ( error ) => {
            
        } );
    }
}

function getSingleMedia( blog_id ) {
  return ( dispatch ) => {

    requestHelpers
      .authenticatedGetRequest( `/blogs/${ blog_id }` )
      .then( ( response) => {
        return dispatch( {
            type: actions.GET_SINGLE_MEDIA,
            singleMedia: response.data,
        } )
      } )
      .catch( ( error ) => {
        console.log( 'error', error )
      } );
  }
}

module.exports = {
    actions,
    getMedia,
    getSingleMedia,
    openPlayer,
    closePlayer
};



// WEBPACK FOOTER //
// src/client/actions/media/media.js